'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _md = require('md5');

var _md2 = _interopRequireDefault(_md);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Using approach described in http://blog.richardweiss.org/2016/12/25/hash-splits.html

var defaultSalt = 'E1F53135E559C253';

exports.default = function (_ref) {
    var userId = _ref.userId,
        _ref$alternatives = _ref.alternatives,
        alternatives = _ref$alternatives === undefined ? [] : _ref$alternatives,
        _ref$salt = _ref.salt,
        salt = _ref$salt === undefined ? defaultSalt : _ref$salt,
        _ref$overrideURLParam = _ref.overrideURLParamName,
        overrideURLParamName = _ref$overrideURLParam === undefined ? null : _ref$overrideURLParam;

    var numAlts = alternatives.length;
    if (numAlts === 0) return null;
    if (numAlts === 1) return alternatives[0];

    // Use overrideURLParamName to grab an override from the URL query string
    // If you want to use a specific alternative number, use param=alt:4
    if (overrideURLParamName && typeof window !== 'undefined' && window.location) {
        var match = RegExp(overrideURLParamName + '=([^&]*)').exec(window.location.search);
        if (match) {
            var chooseAlt = /alt:(.*)/.exec(match[1]);
            if (chooseAlt) {
                var overrideBucket = parseInt(chooseAlt[1]);
                if (isNaN(overrideBucket)) return match[1];
                if (overrideBucket >= numAlts) overrideBucket = numAlts - 1;
                return alternatives[overrideBucket];
            }
            return match[1];
        }
    }

    var hashedValue = parseInt((0, _md2.default)(userId + ',' + salt).substr(0, 6), 16) / 0xFFFFFF;
    var bucket = Math.floor(hashedValue * numAlts);
    if (bucket === numAlts) bucket = bucket - 1; // protect against possible value of 1

    return alternatives[bucket];
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/SplitRunTest.js
// module id = 1142
// module chunks = 0